// Только первым импортом: санитайзер localStorage.AUTH должен отработать раньше keycloakAuth
import '@/services/session/bootstrap';

import Vue from 'vue';
import { i18n } from '@/services/i18n';
import '@/i18n/dateLocale';

import {AxiosPlugin} from '@/axio-plugin';
import {LoggerPlugin} from '@/logger';
import BootstrapVue from 'bootstrap-vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import App from './App.vue';
import router from './router';
import { installSessionGuard, isLeavingToLogin } from '@/services/session/sessionState';
import { installFilterDropdownLayout } from '@/utils/filterDropdownLayout';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(AxiosPlugin);
Vue.use(LoggerPlugin);
Vue.use(Antd);

export { i18n };

declare module 'vue/types/options' {
}

function mountApp() {
  const app = new Vue({
    router,
    render: (h) => h(App),
    i18n,
  });
  // Guard роутера отрабатывает внутри конструктора: раз он уводит на /login, сокет и запросы приложения не нужны
  if (isLeavingToLogin()) { return; }
  app.$mount('#app');
}

// Порядок важен: перехватчики должны встать до первого запроса и guard'ов роутера
installSessionGuard();
installFilterDropdownLayout();
mountApp();
